import React, { Component } from 'react'
import { get } from 'lodash'
import CustomTable from '../../elements/Table/CustomTable'
import withLoadingSection from '../../elements/HOC/withLoadingSection'
import DateTimeCell from '../../elements/Table/Cells/DateTimeCell'
import propTypes from 'prop-types'
import UpperCaseCell from '../../elements/Table/Cells/UpperCaseCell'

function History(props) {
  const { owner, isArray } = props
  const data = isArray
    ? owner._history
    : Object.keys(get(owner, '_history') || {}).map(k => ({
        action: k,
        ...get(owner, '_history')[k],
      }))
  return (
    <CustomTable
      hide={{
        refresh: true,
      }}
      defaultSorted={[
        {
          id: 'date',
          desc: true,
        },
      ]}
      columns={[
        {
          Header: 'Action',
          accessor: 'action',
          Cell: UpperCaseCell,
        },
        {
          Header: 'User',
          accessor: 'name.fn',
        },
        {
          Header: 'Date',
          accessor: 'date',
          Cell: DateTimeCell,
        },
      ]}
      data={data}
    />
  )
}

export default withLoadingSection(History)

History.propTypes = {
  owner: propTypes.any,
  isArray: propTypes.bool,
}

History.defaultProps = {
  owner: {},
  isArray: false,
}
